import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/app/AuthShell";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setSent(data.message); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <AuthShell title="Password dimenticata?" subtitle="Inserisci l'email del tuo account: ti invieremo un link per reimpostare la password.">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="flex items-start gap-3 rounded-xl bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-800">
            <MailCheck className="w-5 h-5 shrink-0" /> <span data-testid="forgot-sent-message">{sent} Il link è valido per 1 ora.</span>
          </div>
          <Link to="/login" className="text-sm font-semibold text-amber-600 inline-flex items-center gap-1" data-testid="forgot-back-login"><ArrowLeft className="w-4 h-4" /> Torna al login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@azienda.it" data-testid="forgot-email-input" />
          </div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-[#0F2942] hover:bg-[#1B3B5F]" data-testid="forgot-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Invia link di reimpostazione"}
          </Button>
          <Link to="/login" className="text-sm font-semibold text-slate-600 hover:text-amber-600 inline-flex items-center gap-1" data-testid="forgot-back-login"><ArrowLeft className="w-4 h-4" /> Torna al login</Link>
        </form>
      )}
    </AuthShell>
  );
}
